export const LOCAL_PHONE_REGEX = /^0\d{9}$/;

export function phoneDigits(phone: string): string {
  return (phone || '').replace(/\D+/g, '');
}

export function normalizeLocalPhone(phone: string): string | null {
  let digits = phoneDigits(phone);

  if (digits.startsWith('94') && digits.length === 11) {
    digits = `0${digits.slice(2)}`;
  } else if (digits.length === 9) {
    digits = `0${digits}`;
  }

  if (!LOCAL_PHONE_REGEX.test(digits)) {
    return null;
  }

  return digits;
}

export function isValidLocalPhone(phone: string): boolean {
  return normalizeLocalPhone(phone) !== null;
}

export function localPhoneValidationMessage(): string {
  return 'Phone number must be 10 digits starting with 0 (no country code).';
}

export function formatPhoneInput(value: string): string {
  let digits = phoneDigits(value);

  if (digits.startsWith('94')) {
    digits = `0${digits.slice(2)}`;
  }

  if (digits.startsWith('0')) {
    return digits.slice(0, 10);
  }

  if (digits.length > 0) {
    return digits.slice(0, 9);
  }

  return '';
}
